
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleAdultChannelContainer from '~/components/child/article/ArticleAdultChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleAdultHotContainer from '~/components/child/article/ArticleAdultHotContainer.vue';
import AdultThemeArticleContainer from '~/components/child/article/AdultThemeArticleContainer.vue';
import { mapActions, mapMutations } from 'vuex';
import BloggerRankingChannelAdult from '~/components/child/blogger/BloggerRankingChannelAdult.vue';
import FalconAd from '~/components/common/widget/FalconAd.vue';
import FalconAdAdult from '~/components/common/widget/FalconAdAdult.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleAdultChannelContainer, BloggerRankingChannel, ArticleAdultHotContainer, AdultThemeArticleContainer, BloggerRankingChannelAdult, FalconAd, FalconAdAdult },
    head() {
        return {
            title: '私康-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦私康頻道（Adult）提供您私人專屬成人好康，精挑細選男女情慾話題，各式各樣難以啟齒的性癖討論各種好奇及疑惑，從男女情事到性事 ，都擁有新的世界！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦私康頻道（Adult）提供您私人專屬成人好康，精挑細選男女情慾話題，各式各樣難以啟齒的性癖討論各種好奇及疑惑，從男女情事到性事 ，都擁有新的世界！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦私康頻道（Adult）提供您私人專屬成人好康，精挑細選男女情慾話題，各式各樣難以啟齒的性癖討論各種好奇及疑惑，從男女情事到性事 ，都擁有新的世界！' },
                { hid: 'keywords', name: 'keywords', content: '成人、BDSM、約炮、情趣、飛機杯、情趣用品、口交、保險套、做愛、av、A片、H漫、調教、潤滑液、自慰、線上看、巨乳、外流、甲、Les、 內射、3P、外流、r18、r20、r25、（限）' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "私康-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_adult_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_adult_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_adult_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_adult_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/adult', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_pet_og.png",
                    "name":"私康-PIXNET痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦私康頻道（Adult）提供您私人專屬成人好康，精挑細選男女情慾話題，各式各樣難以啟齒的性癖討論各種好奇及疑惑，從男女情事到性事 ，都擁有新的世界！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_adult_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "私康-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦私康頻道（Adult）提供您私人專屬成人好康，精挑細選男女情慾話題，各式各樣難以啟齒的性癖討論各種好奇及疑惑，從男女情事到性事 ，都擁有新的世界！",
                            "keywords": "成人、BDSM、約炮、情趣、飛機杯、情趣用品、口交、保險套、做愛、av、A片、H漫、調教、潤滑液、自慰、線上看、巨乳、外流、甲、Les、 內射、3P、外流、r18、r20、r25、（限）"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            check_rule: false,
            channel_page_id: 11,
            category_id: 3,
            showAnimation: false,
            window_width: 0,
            go_fill_birthday: false,
            check_rule_content: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        member_data() {
            return this.$store.state.login.member_data;
        },
        tab_id() {
            return this.$store.state.channel_tab.tab_id;
        },
        tab_left() {
            return this.$store.state.channel_tab.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.channel_tab.tab_highlight_style.width;
        },
        pa_page_name() {
            return '私康';
        },
        tag_search_text() {
            return '私康';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        },
        article_data_1201() {
            return this.$store.state.adult.article_1201;
        },
        article_data_1201_part() {
            return this.$store.state.adult.article_1201.slice(0, 6);
        },
        falconTest() {
            return Boolean(this.$route.query.faTest);
        },
        article_data_1202() {
            if (this.falconTest) return [
                {
                    "type": "html5",
                    "ad_id": "34455",
                    "click_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/r?i=3f42f0f9c59ca71896bbd4a6e2478028&p=4809&u=9321ce7145f34678807b9b3ffb042fdc&c=CgEAxGad96wAAHa3AwzQAg%3D%3D",
                    "counter_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/callback?type=count&hashid=3f42f0f9c59ca71896bbd4a6e2478028&t=&_=1721628589",
                    "title": "html5測試",
                    "material": "//falcon-creative-ak.pixfs.net/test/2024/01/3f42f0f9c59ca71896bbd4a6e2478028-b3202de0f1a90340.html?v=1720062639",
                    "picture": "",
                    "tag": "",
                    "company_name": ""
                },
                ...this.$store.state.adult.article_1202,
            ];
            return this.$store.state.adult.article_1202;
        },
        article_data_1203() {
            if (this.falconTest) return [
                {
                    "type": "falcon",
                    "ad_id": "34451",
                    "click_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/r?i=1296a9412c373713d58bac8557f6ba62&p=4821&u=bf3614f09686495f8efea59430ca747b&c=180be048df854537830d2e5bc7e87a12",
                    "counter_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/callback?type=count&hashid=1296a9412c373713d58bac8557f6ba62&t=&_=1721628951",
                    "title": "",
                    "material": "<ins class=\"adsbyfalcon\" data-ad-client=\"1\" data-ad-slot=\"4821\" style=\"display:inline-block;width:429px;height:337px\"></ins>",
                    "picture": "",
                    "tag": "",
                    "company_name": ""
                },
                ...this.$store.state.adult.article_1203,
            ];
            return this.$store.state.adult.article_1203;
        },
        article_data_1204() {
            if (this.falconTest) return [
                {
                    "type": "video",
                    "ad_id": "34454",
                    "click_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/r?i=d4fa9bb8a392a2787704538570f0312a&p=4825&u=417e63c77ce745a7a22ecf0747d22ced&c=CgEAxGad97EAAHa3AwzUAg%3D%3D",
                    "counter_url": "http://falcon.pixnet.net.101129.alpha.pixnet.work/ad/callback?type=count&hashid=d4fa9bb8a392a2787704538570f0312a&t=&_=1721628593",
                    "title": "",
                    "material": {
                        "video_align": "center",
                        "video_callback_url": "//falcon.pixnet.net.101129.alpha.pixnet.work/ad/vp?i=d4fa9bb8a392a2787704538570f0312a&p=4825&u=44d681e0c3d047a28491ceccdb8fc692",
                        "videofile_mp4": "//falcon-creative-ak.pixfs.net/test/2024/01/d4fa9bb8a392a2787704538570f0312a-ae1b27248b6fef93.mp4?v=1720062588",
                        "videofile_webm": "",
                        "videofile_poster": "//falcon-creative-ak.pixfs.net/test/2024/01/d4fa9bb8a392a2787704538570f0312a-8001707f05c73f78.jpg?v=1720062588"
                    },
                    "picture": "",
                    "tag": "",
                    "company_name": ""
                },
                ...this.$store.state.adult.article_1204,
            ];
            return this.$store.state.adult.article_1204;
        },
        is_adult() {
            return this.$store.state.adult.is_18up;
        }
    },
    methods: {
        ...mapActions('article', [
            'getArticleData'
        ]),
        ...mapActions('adult', [
            'getAdultRanking',
            'getArticleData',
            'getMoreArticleDataWithFalcon'
        ]),
        ...mapMutations('channel_tab', [
            'updateWindowWidth'
        ]),
        ...mapMutations('adult', [
            'changeIs18UpStatus',
            'changeIsNot18UpStatus'
        ]),
        setShowAnimation(){
            setTimeout(()=>{
                this.showAnimation = true;
            }, 500)
        },
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '私康'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '私康'
            });
            this.gtag('event', 'page_view', {
                page_title: '私康-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
        is_18up() {
            if(!this.is_login){
                const url = window.location.host + "/channel/adult";
                location.href = "https://member.pixnet.cc/login/openid?openid=https://member.pixnet.cc/login&easy_login=1&done=https%3A%2F%2F"+ url +"%3Fversions%3D2023";
            } else if(this.$cookies.get(this.member_data.member_uniqid + 'is_adult') == 'true') {
                this.changeIs18UpStatus();
            } else if (this.member_data.member_is_adult) {
                this.changeIs18UpStatus();
                this.$cookies.set(this.member_data.member_uniqid + 'is_adult', 'true')
            } else if (this.member_data.member_is_adult == false) {
                const url = window.location.host;
                location.href = "https://" + url;
            } else {
                this.go_fill_birthday = true;
            }
        },
        rebootPixAd() {
            if(window.PIXFalcon){
                var pixAd;
                pixAd = new PIXFalcon();
                pixAd.placeAds(document);
            }
        },
        handleResize() {
            this.window_width = window.innerWidth;
        },
        toogleCheckRuleContent() {
            this.check_rule_content = !this.check_rule_content;
        },
        checkIsMember18Up() {
            if(!this.member_data.member_is_adult) {
                this.changeIsNot18UpStatus()
            }
        }
    },
    async fetch(){
        const item = { sort: 'hot', type: 'category', pre_page: 10, id: 12, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);

        const param_1201 = {
            channel_id: 1201, 
            page: 1,
            page_size: 20,
            with_author: 1,
            with_images: 1,
        }

        const param_1202 = {
            channel_id: 1202, 
            page: 1,
            page_size: 20,
            with_author: 1,
            with_images: 1,
        }

        const param_1203 = {
            channel_id: 1203, 
            page: 1,
            page_size: 20,
            with_author: 1,
            with_images: 1,
        }
        
        const param_1204 = {
            channel_id: 1204, 
            page: 1,
            page_size: 20,
            with_author: 1,
            with_images: 1,
        }

        await this.$store.dispatch("adult/getArticleDataWithFalcon", param_1201);
        await this.$store.dispatch("adult/getArticleDataWithFalcon", param_1202);
        await this.$store.dispatch("adult/getArticleDataWithFalcon", param_1203);
        await this.$store.dispatch("adult/getArticleDataWithFalcon", param_1204);
    },
    async mounted() {
        window.dataLayer = window.dataLayer || [];
        this.rebootPixAd();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.activeGaPage();
        this.activeMcPage();
        if(this.$cookies.get(this.member_data.member_uniqid + 'is_adult')) {
            this.changeIs18UpStatus();
        }
        this.paFunction();
        this.paScrollFunction();

    },
    watch: {
        is_login: async function() {
            if(this.$cookies.get(this.member_data.member_uniqid + 'is_adult')) {
                this.changeIs18UpStatus();
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
}
